import {
  ContentNugget,
  mapCareerPathResponseToCareerPath,
  PanelNugget,
} from '@backrs_ui/common-ui';

import { nuggetMapper } from '@backrs_ui/grow-ui/src/components/Nuggets/nugget.util';
import { LubavCareerPath } from '@backrs_ui/grow-ui/src/models/models';
import { setCurrentDialogNugget } from '@backrs_ui/grow-ui/src/redux/contentNugget/contentNugget';
import { useAppDispatch } from '@backrs_ui/grow-ui/src/redux/hooks';

interface Props {
  careerPath: LubavCareerPath;
}

export const CareerPathNugget = ({ careerPath }: Props) => {
  const dispatch = useAppDispatch();

  const careerPathNugget: ContentNugget = {
    id: parseInt(careerPath.id),
    slug: careerPath.metadata.name.toLowerCase().replace(/\s+/g, '-'),
    title: careerPath.metadata.name,
    description: careerPath.metadata.description,
    variant: 'career-path',
    is_browsable: true,
    star_rating: 0,
    value_rating: 0,
    career_path_info: mapCareerPathResponseToCareerPath({
      ...careerPath.metadata,
    }),
  };

  return (
    <PanelNugget
      key={careerPath.id}
      title={careerPathNugget.title}
      size="SMALL"
      body={careerPathNugget.description}
      variant={nuggetMapper({ nugget: careerPathNugget })}
      onClick={() => dispatch(setCurrentDialogNugget(careerPathNugget))}
      subText={careerPath.relevance}
    />
  );
};
